module.exports = __webpack_public_path__ + "static/media/icon-facebook.7a586b96.svg";